export const theme = {
  colors: {
    basic: {
      "000": '#FFFFFF',
      "050": '#EEEEE',
      "100": '#C8C8C8',
      "200": '#B0B0B0',
      "300": '#747474',
      "400": '#5F5F5F',
      "500": '#444F55',
      "900": '#333333',
    },
    primary: {
      "100": "#ECEAF5",
      "150": "#C3B8E9",
      "200": "#B4A8DA",
      "300": "#9683CA",
      "350": "#806BB9",
      "400": "#8069BE",
      "500": "#6A50B3",
      "600": "#624BAC",
      "700": "#5542A3",
      "800": "#4A3C99",
      "900": "#151232",
    },
    secondary: {
      "100": "#F2F1FF",
      "200": "#CAC5FA",
      "300": "#B5ACF6",
      "400": "#A594F0",
      "500": "#987DEB",
      "600": "#9173DE",
      "700": "#8767D0",
      "800": "#7E5CC3",
      "900": "#7148AD",
    },
    accent: {
      "100": "#D2C7FE",
      "200": "#B3A0FE",
      "300": "#8E75FE",
      "400": "#5F50F6",
      "500": "#4B3AFF",
      "600": "#3736F8",
      "700": "#052EEF",
      "800": "#0029EA",
      "900": "#001CE4",
    },
    support: {
      green: {
        "050": "#E8F5E9",
        "100": "#C8E6C9",
        "300": "#81C784",
        "500": "#4CAF50",
        "900": "#1B5E20",
      },
      orange: {
        "050": "#FFF3E0",
        "100": "#FFE0B2",
        "300": "#FFB74D",
        "500": "#FF9800",
        "900": "#E65100",
      },
      red: {
        "050": "#FFEBEE",
        "100": "#FFCDD2",
        "300": "#E57373",
        "500": "#BC2418",
        "900": "#A71313",
      }
    },
    card: {
      backgroundStroke: '#DCDDEB',
    },
    text: {
      hint: '#6e7191',
    },
    input: {
      border: {
        focus: '#8069BE',
        default: '#DCDDEB'
      }
    },
    button: {
      filled: {
        background: {
          enabled: '#9683CA',
          hover: '#5542A3',
          disabled: '#f7f7fc',
          pressed: '#4A3C99',
        }
      }
    }
  },
  spacing: {
    xs: '4px',
    s: '8px',
    sm: '12px',
    d: '16px',
    l: '24px',
    xl: '32px',
    xxl: '40px',
  },
  responsive: {
    breakpoints: {
      small: '567px',
      medium: '991px',
      large: '1199px'
    }
  },
  typography: {
    fontFamily: 'Inter, sans-serif',
    h1: {
      fontSize: '32px',
      fontWeight: 'regular',
      lineHeight: 1.5,
    },
    h2: {
      fontSize: '40px',
      fontWeight: 'bold',
      lineHeight: 1.5,
    },
    h3: {
      fontSize: '24px',
      fontWeight: 'bold',
      lineHeight: 1.5,
    },
    h4: {
      fontSize: '22px',
      fontWeight: 'bold',
      lineHeight: 1.5,
    },
    subhead: {
      fontSize: '18px',
      fontWeight: 'bold',
      lineHeight: 1.5,
    },
    body2: {
      fontSize: '16px',
      fontWeight: 'bold',
      lineHeight: 1.5,
    },
    body1: {
      fontSize: '16px',
      fontWeight: 'regular',
      lineHeight: 1.5,
    },
    footnote: {
      fontSize: '14px',
      fontWeight: 'regular',
      lineHeight: 1.5,
    },
    caption2: {
      fontSize: '12px',
      fontWeight: 'bold',
      lineHeight: 1.2,
    },
    caption1: {
      fontSize: '12px',
      fontWeight: 'regular',
      lineHeight: 1.2,
    },
  }
};
